import { parseDateTimeValue } from "./dateTime";

const ADDED_DATE_KEYS = [
  "created_at",
  "createdAt",
  "added_at",
  "addedAt",
  "date_added",
  "dateAdded",
  "inserted_at",
  "insertedAt",
];

export function resolveEntityAddedDate(...sources) {
  for (const source of sources) {
    if (!source || typeof source !== "object") continue;

    for (const key of ADDED_DATE_KEYS) {
      const value = source[key];
      if (value === undefined || value === null) continue;

      const text = String(value).trim();
      if (text) return text;
    }
  }

  return "";
}

export function formatEntityAddedDateText(value) {
  if (!value) return "";

  const date = parseDateTimeValue(value);
  if (Number.isNaN(date.getTime())) return "";

  const weekday = date.toLocaleDateString("en-US", { weekday: "short" });
  const day = date.toLocaleDateString("en-US", { day: "2-digit" });
  const month = date.toLocaleDateString("en-US", { month: "short" });
  const year = date.toLocaleDateString("en-US", { year: "numeric" });

  return `${weekday} ${day} ${month} ${year}`;
}
